/* eslint-disable react/jsx-no-target-blank */
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export function Location() {
  const { t } = useLang();

  // Phone number / email stay as-is; only the labels are localized.
  const contacts = [
    {
      Icon: Phone,
      label: t.contact.labels.phone,
      value: "+964-780-2000-360",
      href: "tel:+9647802000360",
    },
    {
      Icon: MessageCircle,
      label: t.contact.labels.whatsapp,
      value: "+964-770-049-9734",
      href: "https://wa.me/009647700499734",
    },
    {
      Icon: Mail,
      label: t.contact.labels.email,
      value: "doaa@rashad-law.com",
      href: "mailto:doaa@rashad-law.com",
    },
  ];

  return (
    <section
      id="contact"
      className="relative border-t border-primary/10 px-6 lg:px-24"
    >
      <div className="container mx-auto py-16 lg:py-24">
        <SectionHeader
          eyebrow={t.contact.eyebrow}
          title={t.contact.title}
          align="center"
          className="mx-auto"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* Contact info */}
          <Reveal className="rounded-2xl border border-primary/10 bg-white/70 p-8">
            <h3 className="font-serif text-2xl font-semibold text-primary">
              {t.contact.info}
            </h3>
            <ul className="mt-6 space-y-5">
              {contacts.map(({ Icon, label, value, href }) => (
                <li key={label} className="flex items-center gap-4">
                  <span className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-lg border border-secondary/30 bg-primary/5 text-secondary">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div className="flex flex-col">
                    <span className="text-xs uppercase tracking-eyebrow text-gold-deep/80">
                      {label}
                    </span>
                    <a
                      href={href}
                      target="_blank"
                      className="text-lg text-primary/80 transition-colors hover:text-gold-deep"
                    >
                      {value}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>

          {/* Addresses */}
          <Reveal
            delay={0.1}
            className="rounded-2xl border border-primary/10 bg-white/70 p-8"
          >
            <h3 className="font-serif text-2xl font-semibold text-primary">
              {t.contact.offices}
            </h3>
            <ul className="mt-6 space-y-5">
              {t.contact.addresses.map((address) => (
                <li key={address} className="flex items-start gap-4">
                  <span className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-lg border border-secondary/30 bg-primary/5 text-secondary">
                    <MapPin className="h-5 w-5" />
                  </span>
                  <p className="pt-2 text-lg leading-snug text-primary/85">
                    {address}
                  </p>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
